import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { analyticsService } from '../utils/analytics';
import { useCookieConsent } from '../contexts/CookieConsentContext';

const Analytics = () => {
  const location = useLocation();
  const { hasConsent, consent } = useCookieConsent();

  useEffect(() => {
    if (!hasConsent('analytics') || !import.meta.env.VITE_GA_MEASUREMENT_ID) {
      return;
    }

    const script1 = document.createElement('script');
    script1.async = true;
    script1.src = `https://www.googletagmanager.com/gtag/js?id=${import.meta.env.VITE_GA_MEASUREMENT_ID}`;
    document.head.appendChild(script1);

    const script2 = document.createElement('script');
    script2.innerHTML = `
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', '${import.meta.env.VITE_GA_MEASUREMENT_ID}', {
        page_path: window.location.pathname,
      });
    `;
    document.head.appendChild(script2);

    return () => {
      if (document.head.contains(script1)) {
        document.head.removeChild(script1);
      }
      if (document.head.contains(script2)) {
        document.head.removeChild(script2);
      }
    };
  }, [consent]);

  useEffect(() => {
    if (hasConsent('analytics')) {
      analyticsService.trackPageView(location.pathname);
    }
  }, [location.pathname, consent]);

  return null;
};

export default Analytics;